import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getFunctionToAddByConditionAndLanguage from '../../services/functionToAdd/getFunctionToAddByConditionAndLanguage'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchFunctionToAddSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchFunctionToAddCombo ({ conditionType, resolve }) {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const combo = yield call(getFunctionToAddByConditionAndLanguage, auth.token, conditionType)
    yield put(fetchFunctionToAddSuccess(combo))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
    yield call(resolve)
  }
}

export function * watchFetchFunctionToAdd () {
  yield takeLatest(combosActionTypes.FETCH_FUNCTION_TO_ADD, fetchFunctionToAddCombo)
}
